module.exports = __webpack_public_path__ + "img/imge5.ace4fe37.png";